import { TspType } from '@entities/tsp'
import { themeByCSSVariables } from '@shared/lib/theme'

export const getSelectDenominationButtonTextColor = (
  isSelected: boolean,
  tspType: TspType | undefined,
  colorSubcategory?: string
) => {
  if (isSelected) {
    if (tspType === TspType.KEYS) {
      return themeByCSSVariables.colors.text.accent
    }

    return `#${colorSubcategory}`
  }

  if (tspType === TspType.KEYS) {
    return themeByCSSVariables.colors.constant.white
  }

  return themeByCSSVariables.colors.text.inverted
}
